import { IngestLiveTranscriptChunkMutation, IngestLiveTranscriptChunkMutationVariables } from '../../generated/graphql';

import { gql, useMutation } from '@apollo/client';

export const INGEST_LIVE_TRANSCRIPT_CHUNK_MUTATION_GQL = gql`
  mutation IngestLiveTranscriptChunk(
    $appointmentShortId: String!
    $sentences: [LiveTranscriptSentenceInput!]!
    $roomSid: String
  ) {
    ingestLiveTranscriptChunk(appointmentShortId: $appointmentShortId, sentences: $sentences, roomSid: $roomSid) {
      accepted
    }
  }
`;

export function useIngestLiveTranscriptionChunk() {
  return useMutation<IngestLiveTranscriptChunkMutation, IngestLiveTranscriptChunkMutationVariables>(
    INGEST_LIVE_TRANSCRIPT_CHUNK_MUTATION_GQL,
  );
}
